import { Button } from "rsuite"

export default function BasicButton({children, primary, color, width, style, className, orient, ...props}) {
    return (
        <Button
            appearance={primary ? "primary" : "default"}
            className={"basicButton" + " " + className} {...props}
            style={{
                backgroundColor: primary ? "var(--main-color)" : "white",
                color: primary ? "white" : color ? color : "black",
                width: width ? width : "100%",
                display: "flex",
                justifyContent: orient ? orient : "center",
                zIndex: 999,
                ...style
            }}
            onClick={(e) => {
                e.stopPropagation();
                props.onClick && props.onClick(e);
            }}
            {...props}
        >
            {children}
        </Button>
    )
}